import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UnmountClosed } from 'react-collapse/lib/UnmountClosed';
import { AppRemixIcon, AppDeleteModal } from '@/layout/AppComponents';
import axios from 'axios';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

const MilestoneItem = (props) => {
  const { milestone, onRemove } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const global = useSelector((state) => state.global);
  const [isOpened, setIsOpened] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // < REMOVE
  const handleRemove = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath('api_r_user_module_legalCompliance_milestone_remove'),
        { moduleBridgeHex, plantHex, milestoneID: milestone.id },
      );
      if (isMounted.current) {
        setIsRemove(false);
        setIsOpened(false);
        setIsLoading(false);
        onRemove(response.data);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };
  // > REMOVE

  // < ICON
  const getIconType = (reportType) => {
    let type = 'file-';
    if (reportType.startsWith('pdf')) {
      type += 'pdf';
    } else if (reportType.startsWith('xls')) {
      type += 'excel';
    } else if (reportType.startsWith('doc')) {
      type += 'word';
    }

    return type;
  };

  const getIconColor = (reportType) => {
    let color;
    if (reportType.startsWith('pdf')) {
      color = colors.danger;
    } else if (reportType.startsWith('xls')) {
      color = colors.success;
    } else if (reportType.startsWith('doc')) {
      color = colors.primary;
    }

    return color;
  };
  // < ICON

  const handleGetFile = useCallback(
    async (reportType) => {
      axios
        .post(
          axiosPath(
            'api_r_user_module_legalCompliance_milestone_plant_file_get',
          ),
          {
            moduleBridgeHex,
            plantHex,
            milestoneId: milestone.id,
            reportType,
          },
        )
        .then(({ data }) => {
          window.open(data, '_blank', 'noopener,noreferrer');
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [moduleBridgeHex, plantHex, milestone],
  );

  return (
    <div className="mb-3">
      <MilestoneBlockTitle onClick={() => setIsOpened(!isOpened)}>
        {milestone.dateStamp}
        {milestone.name && (
          <>
            {' '}
            - <b>{milestone.name}</b>
          </>
        )}
      </MilestoneBlockTitle>
      <UnmountClosed isOpened={isOpened}>
        <>
          {milestone.comment && (
            <div className="alert alert-info">{milestone.comment}</div>
          )}
          {milestone.reports.length > 0 && (
            <Container>
              {milestone.reports.map((reportType) => (
                <span
                  key={reportType}
                  onClick={() => handleGetFile(reportType)}
                  // href={`${global.urlData.userApiUrl}m/legal-compliance/milestone/get-file/${moduleBridgeHex}/${plantHex}/${milestone.id}/${reportType}`}
                  className="d-block mb-2 pl-2 pointer"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="download.report"
                    />,
                  )}
                >
                  <AppRemixIcon
                    icon={getIconType(reportType)}
                    className="sidebar-icon mr-1"
                    color={getIconColor(reportType)}
                  />
                  <Translator
                    file="module-legalCompliance"
                    name={`module.lc.export.${reportType}`}
                  />
                </span>
              ))}
              <div
                className="text-danger pointer float-right mr-2"
                onClick={() => setIsRemove(true)}
              >
                <AppRemixIcon icon="delete-bin-6" color={colors.danger} />
                <span className="ml-2">
                  <Translator file="user" name="user.delete" />
                </span>
              </div>
              <div className="clearfix" />
            </Container>
          )}
        </>
      </UnmountClosed>
      <AppDeleteModal
        show={isRemove}
        title={<Translator file="user" name="user.remove" />}
        onConfirm={() => (!isLoading ? handleRemove() : undefined)}
        onClose={() => (!isLoading ? setIsRemove(false) : undefined)}
      />
    </div>
  );
};

export default MilestoneItem;

const MilestoneBlockTitle = styled.div`
  color: ${colors.primary};
  font-size: 14px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const Container = styled.div`
  border: 1px solid ${colors.grey300};
  margin-bottom: 5px;
  padding: 10px;
`;
